// Module
var code = "<div class=\"tooltip-arrow\"></div> <div class=\"tooltip-inner\" ng-bind=\"content\"></div> ";
// Exports
export default code;